import { times } from 'lodash';

/* @ngInject */
export function sysvarFormCtrl($scope, $uibModal) {
    this.selected = null;
    this.watcher = null;
    this.sysvars = {};

    this.$postLink = () => {
        if(this.setFormHooks)
            this.setFormHooks({
                setDirty: () => this.generalForm.$setDirty(),
                pristine: () => this.generalForm.$pristine
            });

        if (this.multi && this.multi.cloneMapper) {
            this.selectClone = p => {
                let clone = this.multi.cloneMapper(angular.copy(p));
                this.sysvars[this.multi.varName].val.push(clone);
                this.selected = clone;
                //this.select(clone);
                this.generalForm.$setDirty();
            }
        }
        if (this.multi) {
            // build a simpler, safer data structure
            this.sysvarWatcher = $scope.$watch('$ctrl.sysvars', s => {
                this.multiData = s[this.multi.varName]
                                    ? s[this.multi.varName].val.map(v => ({displayName: v[this.multi.displayField], archived: !!v.archived, el: v}))
                                    : [];
                this.selected = this.multiData[0]?.el;
            });
        }
        if(this.onSelection) 
            this.watcher = $scope.$watch('$ctrl.selected', () => this.onSelection(this.selected));
    }

    this.processSysvars = () => {
        if (this.multi) {
        // build a simpler, safer data structure
            this.multiData = this.sysvars[this.multi.varName]
                                ? this.sysvars[this.multi.varName].val.map(v => ({displayName: v[this.multi.displayField], archived: !!v.archived, el: v}))
                                : [];
            this.selected = this.multiData[0]?.el;
        };
    }

    this.sysvarWatcher = $scope.$watch('$ctrl.sysvars', () => this.processSysvars());

    // helpers for the substates
    this.save = () => this.onSave()
        .then(() => {
            this.generalForm.$setPristine();
            this.processSysvars();              // $watch won't catch property changes
        })
        .catch(err => null);

    this.cancel = () => this.onCancel()
        .then(() => this.generalForm.$setPristine());

    this.selectAdd = function () {
        this.sysvars[this.multi.varName].val.push({ [this.multi.displayField]: '--new--' });
        this.selected = this.sysvars[this.multi.varName].val[this.sysvars[this.multi.varName].val.length - 1];
        this.generalForm.$setDirty();
    }

    this.selectDel = function () {
        var modalInstance = $uibModal.open({
            template: require('./deleteConfirmation.html'),
            size: 'sm',
        });

        modalInstance.result.then(() => {
            _.remove(this.sysvars[this.multi.varName].val, this.selected);
            this.selected = null;
            this.save();
        })
    }
    
    this.showArchived = false;

    this.$onDestroy = () => {
        if(this.watcher)
            this.watcher();
        if(this.sysvarWatcher)
            this.sysvarWatcher();
    }
}
